<template>
  <div
    class="span list-object"
    :style="containerStyle"
  >
    <my-loader v-if="progressOpening" :spacing="150" />
    <v-layout v-else wrap pb-5>
      <template>
        <v-flex xs12>
          <object-images
            :images="objectImagesComputed"
            :compact="!showDesktopVersion"
            :img-folder="'objectImages/large'"
          />
        </v-flex>
        <v-flex xs12
          :class="!showDesktopVersion ? 'px-1' : ''"
        >
          <v-layout
            wrap
          >
            <v-flex
              :xs9="!showDesktopVersion"
              :xs10="showDesktopVersion"
              :class="!showDesktopVersion ? 'px-2' : ''"
            >
              <h1 :class="!showDesktopVersion ? 'mobile-object-name' : ''"
                style="float: left;"
              >
                {{ object.objectName }}
                </h1>
                <div
                  :style="showDesktopVersion
                    ? 'float: left; padding: 30px 0 5px 15px; cursor: pointer; font-size: 16px;'
                    : 'clear: both; padding: 0 0 15px 0; cursor: pointer;'"
                  @click="toggleFavorite(object)"
                >
                  <i
                    :class="isFavorite(object) ? 'fa fa-heart' : 'far fa-heart'"
                    style="color: red; padding-right: 5px;"
                  ></i> {{ $t('save_favorite') }}
                </div>
            </v-flex>
            <v-flex
              :xs3="!showDesktopVersion"
              :xs2="showDesktopVersion"
              :class="'mobile-csr ' + (!showDesktopVersion ? 'px-2' : '')"
            >
              <b>{{ $i18n.t('csr_id') }}: {{ object.csrId }}</b>
            </v-flex>

            <template>
              <v-flex
                xs12
                :class="!showDesktopVersion ? 'px-2' : 'pb-2'"
                style="position: relative;"
              >
                <h3 class="mobile-object-address">{{ object.address }}</h3>
                <main-share
                  v-if="showDesktopVersion"
                  :absolute="true"
                />
              </v-flex>



            </template>

            <template v-if="showDesktopVersion">
              <v-flex
                xs12
                :class="!showDesktopVersion ? 'px-2 py-2' : 'py-2'"
              >
                <input
                  class="button-silver"
                  type="button"
                  :value="'&lt; ' + $t('tagasi')"
                  @click="goBack"
                >
              </v-flex>
              <v-flex
                v-if="0"
                xs6
                :class="!showDesktopVersion ? 'px-2 py-2' : 'py-2'"
              >
                <div style="position:relative">
                  <div style="float: right; top: 0; right: 0; text-align: left;">
                    <input
                      style="margin-left: 10px;"
                      type="button"
                      :value="$t('broneeri_kohe')"
                      @click="navigateToObjectBookingForm(object)"
                    >
                  </div>
                </div>
              </v-flex>
            </template>
            <v-flex xs12 md6 :class="(!showDesktopVersion ? 'px-2' : '') +
              ' pb-2'"
            >
              <v-layout
                v-for="(featureGroup, fgIndex) in featureGroups.filter(fg => fg.showOnObjectPage && (fg.id === '5bc978b1e07c9e232eca5699' || showDesktopVersion))"
                :key="fgIndex"
                wrap
              >
                <object-info-features-for-group
                  :object="object"
                  :feature-group="featureGroup"
                />
              </v-layout>
            </v-flex>
            <v-flex xs12 md6 :class="!showDesktopVersion ? 'px-2' : ''">
              <v-layout
                v-for="(room, rIndex) in objectRoomsComputed"
                :key="rIndex"
                wrap
              >
                <v-flex v-if="objectRoomTypesById[room.type]" xs12>
                  <object-room-features
                    :room="room"
                    :title="objectRoomTypesById[room.type]['typeName_' + lang]"
                    :features-field="featuresFieldToUse(objectRoomTypesById[room.type].typeCode)"
                  />

                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex
              v-if="!showDesktopVersion"
              xs12
              md6
              :class="(!showDesktopVersion ? 'px-2' : '') +
                ' '"
            >
              <v-layout
                v-for="(featureGroup, fgIndex) in featureGroups.filter(fg => fg.showOnObjectPage && (fg.id !== '5bc978b1e07c9e232eca5699'))"
                :key="fgIndex + '_2'"
                wrap
              >
                <object-info-features-for-group
                  :object="object"
                  :index="fgIndex"
                  :feature-group="featureGroup"
                />

              </v-layout>
            </v-flex>

            <v-flex
              :class="(!showDesktopVersion ? 'px-2' : '') +
              ' pb-2'"
            >
              <v-layout wrap align-center justify-center>

                <v-flex
                  :xs10="enableCollapsing"
                  :xs12="!enableCollapsing"
                  :py-2="enableCollapsing"
                  :pt-3="!enableCollapsing"
                  :pb-1="!enableCollapsing"
                  @click="togglePricesCollapsed"
                >
                  <h3>{{ $t('prices') }}</h3>
                </v-flex>
                <v-flex
                  v-if="enableCollapsing"
                  xs2 py-2
                  @click="togglePricesCollapsed"
                  class="feature-collapse-icon">
                  <v-icon small>{{ pricesCollapsed ? 'fa-chevron-down' : 'fa-chevron-up' }}</v-icon>
                </v-flex>

                <v-flex
                  xs12
                  v-if="!pricesCollapsed"
                  :pb-2="enableCollapsing"
                  :pt-2="enableCollapsing"
                >
                  <table
                    v-if="objectPricesComputed.length > 0"
                    :class="'object-prices-table ' + (!showDesktopVersion ? 'object-price-table-mobile' : '')"
                  >
                    <tr>
                      <td xs2 class="in-bold">
                        {{ $i18n.t('hooaeg') }}
                      </td>
                      <td v-if="hasPeriodPrices('dayPrice')" xs2 class="in-bold">
                        {{ $i18n.t('öö') }}
                        <template v-if="!mobile && objectPricesComputed && objectPricesComputed[0] && objectPricesComputed[0].minDays">
                          ({{ $i18n.t('min') }} {{ objectPricesComputed[0].minDays }} {{ $i18n.t('ööd') }})
                        </template>
                      </td>
                      <td v-if="hasPeriodPrices('weekPrice')" xs2 class="in-bold">
                        1 {{ $i18n.t('nädal') }}
                      </td>
                      <td v-if="hasPeriodPrices('twoWeekPrice')" xs2 class="in-bold">
                        2 {{ $i18n.t('weeks') }}
                      </td>
                      <td v-if="hasPeriodPrices('monthPrice')" xs4 class="in-bold">
                        {{ $i18n.t('month') }}
                        <template v-if="!mobile && objectPricesComputed && objectPricesComputed[0] && objectPricesComputed[0].minMonths">
                          ({{ $i18n.t('min') }} {{ objectPricesComputed[0].minMonths }} {{ $i18n.t('kuud') }})
                        </template>
                      </td>
                    </tr>
                    <tr
                      v-for="(price, priceIndex) in objectPricesComputed"
                      :key="priceIndex"
                    >
                      <td xs2 :key="priceIndex + '_1'">
                        {{ price.dateStart }} -
                        {{ price.dateEnd }}
                      </td>
                      <td v-if="hasPeriodPrices('dayPrice')" xs2 :key="priceIndex + '_2'">
                        {{ price.dayPrice ? price.dayPrice + ' €' : null }}
                      </td>
                      <td v-if="hasPeriodPrices('weekPrice')" xs2 :key="priceIndex + '_3'">
                        {{ price.weekPrice ? price.weekPrice + ' €' : null }}
                      </td>
                      <td v-if="hasPeriodPrices('twoWeekPrice')" xs2 :key="priceIndex + '_4'">
                        {{ price.twoWeekPrice ? price.twoWeekPrice + ' €' : null }}
                      </td>
                      <td v-if="hasPeriodPrices('monthPrice')" xs4 :key="priceIndex + '_5'">
                        {{ price.monthPrice ? price.monthPrice + ' €' : null }}
                      </td>
                    </tr>
                  </table>
                </v-flex>
                <v-flex xs12 v-if="enableCollapsing && pricesCollapsed">
                  <div style="border-bottom: 1px solid #ddd; height: 1px; width: 100%;"></div>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex
              v-if="false"
              xs12
              :class="!showDesktopVersion ? 'px-2' : ''"
            >
              <div float:left>
                <div class="list-object-text object-properties-div" style="float: left;"
                  v-html="objectInfoShort"
                >
                </div>
                <div class="list-object-text object-properties-div" style="float: left;clear:both;"
                  v-html="objectInfoExtended"
                >
                </div>
                <div v-html="object.properties"></div>
              </div>
            </v-flex>
            <v-flex xs12 py-3 px-2 v-if="object.touristPermit">
              <v-icon small>fa-certificate</v-icon> {{ $i18n.t('tourist_license') }}: {{ object.touristPermit }}
            </v-flex>
            <v-flex
              v-if="!showDesktopVersion"
              xs12 :class="'px-2'"
            >
              <contact-us-menu
                :contact-options="contactOptions"
              />
            </v-flex>

            <v-flex xs12
              v-if="showDesktopVersion"
              v-html="$i18n.t('object_info_contacts')"
              :class="!showDesktopVersion ? 'px-2 pt-3' : ''"
              style="font-weight: 700; color: rgb(33, 154, 200);"
            >
          </v-flex>

            <!-- v-flex v-if="!mobile" xs12 :class="!showDesktopVersion ? 'px-2' : ''">
              <object-price :object="object" />
            </v-flex -->


            <v-flex
              v-if="object.calendar && !showDesktopVersion"
              xs6 px-2 mt-3 pt-2
            >
              <span style="font-size: 17px;"><b>{{ $i18n.t('check_in') }}</b></span> <br />
              <template v-if="searchFilters.dateStart">
                <span class="mobile-selected-date">{{ searchFilters.dateStart }}</span>
              </template>
              <template v-else>
                <span style="color: red;">
                  {{ $i18n.t('select_date') }} &darr;
                </span>
              </template>
            </v-flex>
            <v-flex
              v-if="object.calendar && !showDesktopVersion"
              xs6 px-2 mt-3 pt-2
            >
              <span style="font-size: 17px;"><b>{{ $i18n.t('check_out') }}</b></span> <br />
              <template v-if="searchFilters.dateEnd">
                <span class="mobile-selected-date">{{ searchFilters.dateEnd }}</span>
              </template>
              <template v-else-if="searchFilters.dateStart">
                <span style="color: red;">
                  {{ $i18n.t('select_date') }} &darr;
                </span>
              </template>
              <template v-else>
                - - - - - - -
              </template>
            </v-flex>
            <v-flex
              v-if="!showDesktopVersion"
              xs12 mx-2
            >
              <calendar-navigation
                :show-overlay="!object.calendar"
              />
              <div style="position: relative;"
                v-if="searchFilters.dateEnd || searchFilters.dateStart"
                @click="clearSearch()"
              >
                <div style="position: absolute; top: 10px; right: 5px;">
                  <a>{{ $i18n.t('clear_days') }}</a>
                </div>
              </div>
              <calendar-legend />
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex mt-3 xs12 v-if="mapCoords">
          <Map
            v-if="renderMap"
            :map-coords="mapCoords"
          />
          <!-- iframe
            width="100%"
            height="400"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            :src="'https://maps.google.com/maps?q=' + mapCoords +'&z=12&key=' + googleMapsKey"
           >
         </iframe -->
        </v-flex>


        <v-flex
          :xs10="enableCollapsing"
          :xs12="!enableCollapsing"
          :py-2="enableCollapsing"
          :pt-3="!enableCollapsing"
          :pb-1="!enableCollapsing"
          px-2
          @click="toggleRulesCollapsed"
        >
          <h3>{{ $t('conditions_title') }}</h3>
        </v-flex>
        <v-flex
          v-if="enableCollapsing"
          xs2 py-2 pr-2
          @click="toggleRulesCollapsed"
          class="feature-collapse-icon">
          <v-icon small>{{ rulesCollapsed ? 'fa-chevron-down' : 'fa-chevron-up' }}</v-icon>
        </v-flex>

        <template v-if="!rulesCollapsed">
          <v-flex xs12 px-2 py-1>
            <v-icon small class="condition-icon">fa-key</v-icon> {{ $i18n.t('condition_register_in') }}
            <br>
            <span style="padding-left: 30px;">{{ $i18n.t('condition_register_out') }}</span>
          </v-flex>
          <v-flex xs12 px-2 py-1>
            <v-icon small class="condition-icon">fa-moon</v-icon>
            {{ $i18n.t('condition_night_peace') }}
          </v-flex>
          <v-flex xs12 px-2 py-1>
            <v-icon small class="condition-icon">fa-ban</v-icon>
            {{ $i18n.t('no_parties') }}
          </v-flex>
          <v-flex xs12 px-2 py-1>
            <v-icon small class="condition-icon">fa-smoking-ban</v-icon>
            {{ $i18n.t('condition_smoking') }}
          </v-flex>
        </template>
      </template>
      <v-bottom-nav
        v-if="!showDesktopVersion"
        :value="true"
        fixed
        color="white"
        height="80px"
      >
        <v-layout wrap>
          <v-flex
            v-if="bookingPeriod && bookingNights"
            xs6 style="padding: 5px 15px; font-size: 12px; color: #219AC8; text-align: center;"
          >
            {{ bookingPeriod }}
            <br>
            <span style="font-size: 18px; font-weight: 900;">
              {{ mobileBottomPriceText }}
            </span>
            <br>
            {{ bookingNights }} {{ parseInt(priceObject.bookingDays) === 1 ? $i18n.t('öö').toLowerCase() : $i18n.t('ööd') }}
            <template v-if="displayPrice === '? '">
              <br>
              <span style="color: red;"><b>{{ $i18n.t('dates_not_available_short') }}</b></span>
            </template>
          </v-flex>
          <v-flex
            :class="bookingPeriod && bookingNights ? 'xs6' : 'xs12'"
          >
            <div style="padding: 5px 0">
              <input
                style="margin: 5px 15px 3px 15px; height: 35px; font-size: 16px; width: calc(100% - 30px);"
                type="button"
                :value="$t('broneeri_kohe')"
                @click="navigateToObjectBookingForm(object)"
              >
            </div>
            <div style="height: 22px; text-align: center; font-size: 11px;">
              <b>{{ $i18n.t('no_charges_yet') }}</b>
            </div>
          </v-flex>
        </v-layout>
      </v-bottom-nav>
    </v-layout>
  </div>
</template>

<script>
import Map from './../components/Map'
import sharedComputed from './../views/sharedComputed'
import MainShare from './_MainShare'
import sharedMethods from './../methods/sharedMethods'
import ContactUsMenu from './../components/_ContactUsMenu'
import ObjectInfoFeaturesForGroup from './ObjectInfoFeaturesForGroup'
import ObjectRoomFeatures from './../components/ObjectRoomFeatures'
import MyLoader from './../components/_MyLoader'
import methods from './../methods'
import ObjectPrice from './ObjectPrice'
import ObjectImages from './ObjectImages'
import { createHelpers } from 'vuex-map-fields'
import CalendarNavigation from './../components/CalendarNavigation'
import CalendarLegend from './../components/CalendarLegend'
import state from './../state.js'
import moment from 'moment'
import helper from "@/helper";

const isFacebookApp = () => {
  let ua = navigator.userAgent || navigator.vendor || window.opera;
  return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectsInfo',

  data () {
    return {
      pricesCollapsed: false,
      rulesCollapsed: false,
      enableCollapsing: false,
      renderMap: false
    }
  },

  components: {
    ObjectImages,
    ObjectPrice,
    CalendarNavigation,
    MyLoader,
    ContactUsMenu,
    ObjectRoomFeatures,
    ObjectInfoFeaturesForGroup,
    MainShare,
    CalendarLegend,
    Map
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    mobileBottomPriceText () {
      if (this.priceObject.bookingDays >= 61) {
        const monthPrice = Math.round(this.priceObject.bookingPrice / this.priceObject.bookingDays * 30)
        return monthPrice + '€ / ' + this.$i18n.t('month').toLowerCase()
      }
      return this.priceObject.bookingMinPeriodPrice
          ? this.priceObject.bookingMinPeriodPrice > this.priceObject.bookingPrice
              ? this.priceObject.bookingMinPeriodPrice + ' €'
              : this.priceObject.bookingPrice + ' €'
          : '&nbsp;'
    },

    containerStyle () {
      let style = {
        borderRadius: 0
      }
      if (!this.showDesktopVersion && !isFacebookApp()) {
        style.paddingTop = '6px'
        style.marginTop = '42px'
      }
      return style
    },

    displayPrice () {
      if (this.priceObject.bookingPrice && this.priceObject.bookingDays && this.priceObject.bookingDays > 0 && !this.loadingObjectInfo) {
        return parseInt(this.priceObject.bookingPrice / this.priceObject.bookingDays * 100) / 100
      }
      if (this.loadingObjectInfo) {
        return '... '
      }
      return '? ' //this.object.dayPrice || (Math.ceil(this.object.price / 7))
    },

    objectRoomsComputed () {
      if (!this.object || !this.object.objectRooms) { return  [] }
      return this.object.objectRooms.sort((a, b) => {
        return parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
      })
    },

    objectImagesComputed () {
      if (!this.object || !this.object.objectImages) { return  [] }
      return this.object.objectImages.sort((a, b) => {
        return parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
      })
    },

    objectPricesComputed () {
      if (!this.object || !this.object.prices) { return  [] }
      return this.object.prices.sort((a, b) => {
        return parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
      })
    },

    bookingPeriod () {
      moment.locale(this.lang)
      if (this.searchFilters.dateStart && this.searchFilters.dateEnd) {
        return moment(this.formatYMD(this.searchFilters.dateStart)).format('D. MMM') +
        ' - ' +
        moment(this.formatYMD(this.searchFilters.dateEnd)).format('D. MMM')
      }
      return null
    },

    bookingNights () {
      if (this.searchFilters.dateStart && this.searchFilters.dateEnd) {
        return moment(this.formatYMD(this.searchFilters.dateEnd)).diff(
          moment(this.formatYMD(this.searchFilters.dateStart)), 'days'
        )
      }
      return
    },

    objectFeatures () {
      if (!this.object.features) { return [] }
      return Object.keys(this.object.features).map(id => {
        let feature = this.object.features[id]
        feature['id'] = id
        return feature
      })
    },

    mapCoords () {
      let tmp = this.object.mapCoords && this.object.mapCoords.split(',')
      if (!tmp || !tmp[0] || !tmp[1]) {
        return false
      }
      return { lat: parseFloat(tmp[0].trim()),
        lng: parseFloat(tmp[1].trim()) }
      // tmp[0].trim() + ',' + tmp[1].trim()
    },

    objectInfoShort () {
      if (this.templateVarsByLang && this.templateVarsByLang[this.lang]) {
        return methods.replaceVars(this.object.propertiesShort, this.templateVarsByLang[this.lang])
      }
      return null
    },

    objectInfoExtended () {
      if (this.templateVarsByLang && this.templateVarsByLang[this.lang]) {
        return methods.replaceVars(this.object.propertiesExtended, this.templateVarsByLang[this.lang])
      }
      return null
    }
  },

  props: {
    object: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  created () {
    if (this.mobile) {
      this.rulesCollapsed = true
      this.pricesCollapsed = true
      this.enableCollapsing = true
    }
    this.setNavigationCalendarMonth()
  },

  mounted () {
    this.renderMap = true
  },

  methods: {
    ...sharedMethods,

    setNavigationCalendarMonth () {
      if (!this.searchFilters.dateStart) { return }
      this.calendarMonth = moment(helper.dateToYMD(this.searchFilters.dateStart)).format('MM')
      this.calendarYear = moment(helper.dateToYMD(this.searchFilters.dateStart)).format('YYYY')
    },

    togglePricesCollapsed () {
      if (this.enableCollapsing) {
        this.pricesCollapsed = !this.pricesCollapsed
      }
    },

    toggleRulesCollapsed () {
      if (this.enableCollapsing) {
        this.rulesCollapsed = !this.rulesCollapsed
        this.$nextTick(() => {
          window.scrollTo(0, document.body.scrollHeight)
        })
      }
    },

    featuresFieldToUse (typeName) {
      if (typeName === 'bedroom') { typeName = 'livingroom' } // Share same type
      return typeName + 'Features'
    },

    hasPeriodPrices (pricePeriod) {
      if (!this.object.prices || this.object.prices.length === 0) { return false }
        return this.object.prices.filter(price => price[pricePeriod]).length > 0
    },

    openContactLink (contactLink) {
      window.open(contactLink)
    },

    goBack () {
      window.history.back()
    }
  }
}
</script>

<style>
table {
  border-collapse: collapse;
}

.object-prices-table {
  width: 100%;
  table-layout: fixed;
}
.object-price-table-mobile {
  width: 100%;
  margin: 0;
}
.object-prices-table tr {
  border-bottom: 1px solid #ddd;
}
/*.object-prices-table tr:last-child {
  border-bottom: none;
}*/
.object-prices-table td {
  padding: 3px 5px 2px 0px;
}
.mobile-object-address {
  /* color: #ffcb01; */
  font-size:
}
.mobile-object-name {
  font-size: 26px;
}
.mobile-csr {
  margin-top: 32px;
  text-align: right;
  padding-right: 10px !important;
}
.in-bold {
  font-weight: bold;
}
.back-button {
  float: right;
}
.price-title {
  padding: 15px 0 10px 0;
}
.object-properties-div ul li:before {
    content: "- ";
    padding-right: 7px;
    display: table-cell;
    text-align: left;
}
.price-table tbody tr td p {
  margin-bottom: 3px;
}
.normal-link {
  text-decoration: inherit;
  color: inherit;
}
.condition-icon {
  padding: 0 5px;
}
.mobile-selected-date {
  color: #219bc8 !important;
  font-weight: 700;
}
</style>
